import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NJButton, NJIconButton, NJText } from '@engie-group/fluid-design-system-react';
import { updateComment, type Comment } from '../bffComments';

export function ThreadActions({ comment, slug, onMove, onStatusChanged, compact = false }: {
  comment: Comment; slug: string; onMove?: () => void; onStatusChanged?: () => void; compact?: boolean;
}) {
  const client = useQueryClient();
  const [error, setError] = useState(false);
  const { mutate, isPending } = useMutation({
    mutationFn: () => updateComment(slug, comment.commentId, { resolved: !comment.resolved }),
    onSuccess: () => {
      setError(false);
      onStatusChanged?.();
      void client.invalidateQueries({ queryKey: ['comments', slug] });
    },
    onError: () => setError(true),
  });
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--nj-semantic-size-spacing-8)' }}>
      {compact ? (
        <NJIconButton label={comment.resolved ? 'Rouvrir' : 'Résoudre'} title={comment.resolved ? 'Rouvrir' : 'Résoudre'}
          icon={comment.resolved ? 'restart_alt' : 'check_circle'} variant="tertiary" scale="sm"
          isDisabled={isPending} onClick={() => mutate()} />
      ) : (
        <NJButton label={comment.resolved ? 'Rouvrir' : 'Résoudre'} variant="secondary" scale="sm"
          disabled={isPending} onClick={() => mutate()} />
      )}
      {onMove && <NJButton label="Repositionner" variant="secondary" scale="sm" onClick={onMove} />}
      {error && <NJText scale="xs" role="alert">Impossible de changer le statut. Réessaie.</NJText>}
    </div>
  );
}
